<template>
	<div>
		<!-- Tree of Benefits -->
		<j-card class="bg5">
			<j-expendable-box v-if="computedTree.length">
				<div class="fs3 c2 fw7 p3" slot="header">
					{{ $t("benefits_summary") }}
				</div>
				<div slot="body" class="p2">
					<div v-for="(item, i) in computedTree" :key="i">
						<benefit-summary-node :node="item" class="mb2" />
					</div>
				</div>
			</j-expendable-box>

			<!-- If no data -->
			<div v-if="!isLoading && computedTree.length === 0" class="fs3 ta2 p2">
				{{ $t("errors.no_data") }}
			</div>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JExpendableBox from "@/components/JExpendableBox"
import BenefitSummaryNode from "./BenefitSummaryNode"

export default {
	components: { JCard, JExpendableBox, BenefitSummaryNode },

	props: {
		isLoading: {
			type: Boolean,
			required: false,
			default: false
		},

		// benefitGraph
		tree: {
			type: Array,
			default: () => []
		}
	},

	computed: {
		computedTree() {
			return this.tree || []
		}
	}
}
</script>
